const awsConfig = {
    Auth: {
        Cognito: {
            userPoolId: import.meta.env.VITE_AWS_USER_POOL_ID as string,
            userPoolClientId: import.meta.env.VITE_AWS_USER_POOL_CLIENT_ID as string,
            // identityPoolId: import.meta.env.VITE_IDENTITY_POOL_ID!,
            signUpVerificationMethod: "code" as "code" | "link", // 'code' | 'link'
            loginWith: {
                oauth: {
                    domain: import.meta.env.VITE_AWS_OAUTH_DOMAIN as string,
                    scopes: ["phone", "email", "openid", "aws.cognito.signin.user.admin"],
                    responseType: "code" as "code" | "token",
                    redirectSignIn: import.meta.env.VITE_AWS_OAUTH_REDIRECT_SIGNIN
                        ? [`${import.meta.env.VITE_AWS_OAUTH_REDIRECT_SIGNIN}`]
                        : [window.location.origin],
                    redirectSignOut: import.meta.env.VITE_AWS_OAUTH_REDIRECT_SIGNOUT
                        ? [`${import.meta.env.VITE_AWS_OAUTH_REDIRECT_SIGNOUT}`]
                        : [window.location.origin],
                },
            },
        },
    },
};

export default awsConfig;
